<template>
    <div class="flex wrap large fixed fixed-max-sm top stretch">
        <div class="flex-xs-12 flex-sm-12 flex-md-4 flex-lg-4 comparerates">
              <form novalidate class="form grid xs-grid-cols-1">
                  <ul class="tab tab-pills">
                      <li>
                          <a role="button" @click="setRateFlag(false)" :class="{active: !rates.isRefinance}">Purchase</a>
                      </li>
                      <li>
                          <a role="button" @click="setRateFlag(true)" :class="{active: rates.isRefinance}">Refinance</a>
                      </li>
                  </ul>
                  <div class="group">
                      <mvtTextbox>
                          <div class="input">
                              <label>{{ molang('search.common.zipCode') }}</label>
                              <input v-model.trim="rates.zipcode" ref="zipcode" type="text" name="zipcode" :maxlength="validZipLength" v-validate="'required|zipcode'" />
                          </div>
                      </mvtTextbox>
                  </div>
                  <div class="group">
                      <mvtTextbox>
                          <div class="input">
                              <label>Property Value</label>
                              <mvtInputNumber v-model="rates.propertyValue" :prefix="'$'" v-validate="'required'" />
                          </div>
                      </mvtTextbox>
                  </div>
                  <div class="group in-line">
                      <mvtTextbox>
                          <div class="input">
                              <label>Loan Amount</label>
                              <mvtInputNumber v-model="rates.loanAmount" :prefix="'$'" v-validate="'required'" />
                          </div>
                      </mvtTextbox>
                      <mvtTextbox>
                          <div class="input">
                              <label>Percent Down</label>
                              <mvtInputDecimalNumber v-model="rates.downpaymentRate" :suffix="'%'" @input="updataDownpayment" v-validate="'required'" />
                          </div>
                      </mvtTextbox>
                  </div>
                  <div class="group">
                      <div class="input">
                          <label>Loan Type</label>
                          <mvtSelect v-model="rates.loanPeriod" :data="loanPeriodList" v-validate="'required'" />
                      </div>
                  </div>
                  <div class="group">
                      <div class="input">
                          <label>Credit Score</label>
                          <mvtSelect v-model="rates.creditScore" :data="creditScoreList" v-validate="'required'" />
                      </div>
                  </div>
                  <div v-show="showExtraFields" class="group">
                      <div class="input">
                          <label>Property Type</label>
                          <mvtSelect v-model="rates.propertyType" :data="propertyTypeList" v-validate="'required'" />
                      </div>
                  </div>
                  <div v-show="showExtraFields" class="group">
                      <div class="input">
                          <label>Property Use</label>
                          <mvtSelect v-model="rates.propertyUse" :data="propertyUseList" v-validate="'required'" />
                      </div>
                  </div>
                  <div v-show="showExtraFields" class="group">
                      <div class="input">
                          <label>Military / Veteran</label>
                          <mvtSelect v-model="rates.militaryVeteran" :data="militaryVeteranList" v-validate="'required'" />
                      </div>
                  </div>
                  <div v-show="showExtraFields" class="group">
                      <div class="input">
                          <label>Mortgage Points</label>
                          <mvtSelect v-model="rates.mortgagePoints" :data="mortgagePointsList" v-validate="'required'" />
                      </div>
                  </div>
                  <div v-show="rates.isRefinance && showExtraFields" class="group">
                      <div class="input">
                          <label>Cash Out Amount</label>
                          <mvtInputNumber v-model="rates.cashOutAmount" :prefix="'$'" v-validate="'required'" />
                      </div>
                  </div>
                  <div v-show="showExtraFields" class="group">
                      <div class="input">
                          <label>Include FHA loan options</label>
                          <mvtCheckbox v-model="rates.fhaLoan" :data="fhaLoanData" style="display: inline"></mvtCheckbox>
                      </div>
                  </div>
                  <div class="group">
                      <a @click="() => { showExtraFields = !showExtraFields }" href="javascript:void(0)" class="link">
                          {{ `Show ${showExtraFields ? 'fewer' : 'more'} options` }}
                      </a>
                  </div>
              </form>
        </div>
        <div class="flex-xs-12 flex-sm-12 flex-md-8 flex-lg-8">
            <div v-if="informaDisclosureContent" class="ad-disclosure m-b-2" :class="{'cordless': cordlessLoaded}">
                <a class="f7 link" href="javascript:;" rel="nofollow" v-tip :tip="informaDisclosureContent">Advertiser Disclosure</a>
            </div>
            <div class="mortgages-container" :class="{'cordless': cordlessLoaded}">
                <img v-show="isFetchingMortgages" src="/css/desktop/img/loading-data.gif" loading="lazy" class="loading-data" />
                <div class="mortgage-info-headers" v-if="mortgageRates.length">
                    <div class="info-header">Lender</div>
                    <div v-for="sort in mortgageSort" class="info-header" :class="{'desc': sort.descending, 'active': sort.active }">
                        <a @click="sortMortgageBy(sort.value, !sort.descending)" class="info">
                            {{ sort.text }}
                        </a>
                    </div>
                </div>
                <div v-for="mortgage in filteredMortgageRates" class="mortgage-rate-card" :class="{ 'sponsored': mortgage.SPONSORED === 'Yes' }">
                    <div class="lender-logo">
                        <span class="advertisement" v-if="mortgage.advertiserPLabel">{{ mortgage.advertiserPLabel }}</span>
                        <img :src="mortgage.logo" />
                    </div>
                    <div class="lender-rating">
                        <div class="type">{{ mortgage.productText }}</div>
                        <div class="license">NMLS #{{ mortgage.NMLS }}</div>
                    </div>
                    <div class="mortgage-info-headers">
                        <div v-for="sort in mortgageSort" class="info-header">
                            <div class="info">
                                {{ sort.text }}
                            </div>
                        </div>
                    </div>
                    <div class="rates-info">
                        <div class="rates apr">
                            <div class="value">{{ mortgage.apr }}%</div>
                            <div class="sub-info">{{ mortgage.date }}</div>
                        </div>
                        <div class="rates rate">
                            <div class="value">{{ mortgage.rate }}%</div>
                            <div class="sub-info">Points: {{ mortgage.discpoints }}</div>
                        </div>
                        <div class="rates fees">
                            <div class="value">{{ $filters.formatPrice(mortgage.estpayment) }}</div>
                            <div class="sub-info">Fees: {{ $filters.formatPrice(mortgage.fees) }}</div>
                        </div>
                    </div>
                    <div class="action" @click="nextBtn">
                        <a :href="mortgage.cpc" class="btn primary regular"  target="_blank">Next</a>
                    </div>
                    <div class="tag default active" v-if="mortgage.SPONSORED === 'Yes'">Sponsored</div>
                </div>
                <div v-if="cordlessLoaded" id="cmrtwidget"></div>
                <div v-else-if="!isFetchingMortgages && !mortgageRates.length" class="no-details">No Rates Match Your Criteria</div>
                <a href="javascript:;" class="rates-toggle" v-if="mortgageRates && mortgageRates.length > 5" v-on:click="showAllRates = !showAllRates">
                    <div v-if="showAllRates">Show Less <i class="f7 icon-angle-up" /></div>
                    <div v-if="!showAllRates">Show more <i class="f7 icon-angle-down" /></div>
                </a>

                <div class="data-provider" v-if="isBankRate">
                    <div>
                        <div class="flex left">Powered by <img loading="lazy" :src="glb.cdnUrl + 'vimages/bankrate.svg'" alt="bankrate" /></div>
                        <div>
                            Bankrate, LLC <b>NMLS #1427381</b>
                            <span class="text-gray">|</span>
                            BR Tech Services, Inc. <b>NMLS #1743443</b>
                        </div>
                        <div>
                            <a
                                class="link"
                                href="javascript:;"
                                rel="nofollow"
                                v-tip
                                tip="The listings that appear on this page are from companies from which this website and Bankrate receives compensation, which may impact how, where and in what order products appear. This table does not include all companies or all available products. Bankrate does not endorse or recommend any companies."
                                >Advertiser Disclosure</a
                            >
                            <span class="text-gray">|</span>
                            <a class="link" href="https://www.bankrate.com/privacy/" rel="nofollow noreferrer" target="_blank">Privacy Policy</a>
                            <span class="text-gray">|</span>
                            <a class="link" href="javascript:;" rel="nofollow" v-tip tip="30 year mortgage offers are based on a 20% down payment and 360 equal monthly payments. Monthly payment does not include taxes or insurance. Actual monthly payment will be higher.">Details</a>
                        </div>
                    </div>
                </div>
                <div class="data-provider" v-else-if="informaDisclaimer && !cordlessLoaded" v-html="informaDisclaimer"></div>

            </div>
        </div>
    </div>
</template>

<script src="./comparerates.js"></script>
<style lang="scss">
    @use './comparerates.scss' as *;
</style>
